module.exports = __webpack_public_path__ + "img/pupilpath.3dbebcc4.png";